import { useAuth } from "@/context/authContext";
import { useView } from "@/context/viewContext";
import { api } from "@/utils/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useSession = () => {
  const { dispatch } = useAuth();
  const { setViewAs } = useView();
  const navigate = useNavigate();

  const session = async () => {
    try {
      const response = await api("/auth/session", { method: "GET" }, dispatch);


      dispatch({
        type: "LOGIN",
        payload: {
          user: response.user,
          accessToken: response.accessToken,
        },
      });
      setViewAs(response.user.role);

      navigate("/dashboard");
    } catch {
      toast.error("An error occurred, please try again");
      navigate("/login");
    }
  };

  return { session };
};
